import { render, staticRenderFns } from "./userhome.vue?vue&type=template&id=6255186b&scoped=true"
import script from "./userhome.vue?vue&type=script&lang=js"
export * from "./userhome.vue?vue&type=script&lang=js"
import style0 from "./userhome.vue?vue&type=style&index=0&id=6255186b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6255186b",
  null
  
)

export default component.exports